import Head from 'next/head';
import Link from 'next/link';
import { useState, useEffect } from 'react';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import { gql } from "@apollo/client";
import client from "../apollo-client";
import Acknowledgment from '../components/Acknowledgment';

export async function getStaticProps() {
    const { data } = await client.query({
      query: gql`{
      teamMembers(first:50, where: {orderby: {field: DATE, order: ASC}}) {
        edges {
          node {
            title
            content
            teamMemberDetails {
              category
              email
              linkedin
              position
              pronouns
              picture {
                mediaItemUrl
              }
            }
          }
        }
      }
    }
      `,
    });

    return {
      props: {
        teamMembers: data.teamMembers.edges,
      },
      revalidate: 10,
   };
}

const AboutUs = ({teamMembers}) => {

   
    return(
        <div>
            <Head>
                <title>About Us - Spark Foundation</title>
                <link rel="icon" href="/favicon-32x32.png" />
                <meta property="og:title" content="About Us - Spark Foundation<" key="title" />
                <meta name="description" content="" />
            </Head>

            <div className="relative z-10">
            <Nav/>
            <main className="lg:relative">
                    <div className="relative">
                        <div className="absolute inset-x-0 h-full bg-spark-yellow"></div>
                            <div className="absolute inset-0">
                                <img className="h-full w-full object-cover" src="images/Innovation_Female.jpg" alt="Girl Reading"/>
                                <div className="h-full absolute inset-0 bg-spark-yellow" style={{'mix-blend-mode': 'multiply'}}></div>
                            </div>
                        <div className="max-w-7xl mx-auto sm:px-6 lg:px-8">
                       
                            <div className="relative px-4 py-16 sm:px-6 sm:py-24 lg:py-32 lg:px-8">
                                <h1 className="text-center text-4xl font-extrabold tracking-tight sm:text-5xl lg:text-7xl mt-16">
                                    <span className="block text-white">ABOUT US</span>
                                </h1>

                                <div className="mt-10 max-w-sm mx-auto sm:max-w-none sm:flex sm:justify-center">
                            
                                </div>
                            </div>
                    
                        </div>
                    </div>
                </main>
            </div>
            <Acknowledgment/>

            {/* ABOUT US */}
            <section>
                <div className="bg-white overflow-hidden">
                <div className="relative max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
                    <div className="mx-auto text-base max-w-prose lg:grid lg:grid-cols-2 lg:gap-8 lg:max-w-none">
                    <div>
                        <h2 className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">The Story of SPARK</h2>
                    </div>
                    </div>
                    <div className="mt-8 lg:grid lg:grid-cols-2 lg:gap-8">
                    <div className="relative lg:row-start-1 lg:col-start-2">
                        <div className="relative text-base mx-auto max-w-prose lg:max-w-none">
                        <figure>
                            <div className="aspect-w-12 aspect-h-7 lg:aspect-none">
                                <img className="rounded-lg shadow-lg object-cover object-center" src="images/founders.jpg" alt="Spark Foundation Picture" width="1184" height="1376"/>
                            </div>
                        </figure>
                        </div>
                    </div>
                    <div className="mt-8 lg:mt-0">
                        <div className="text-base max-w-prose mx-auto lg:max-w-none">
                        <p className="text-lg text-gray-500">One sunny Sunday afternoon, two friends were journeying home after a packed weekend of conferences and workshops. During their ride, they discussed the potential impact young people could have if they united.  </p>
                      
                        </div>
                        <div className="text-lg mt-5 prose prose-indigo text-gray-500 mx-auto lg:max-w-none lg:row-start-1 lg:col-start-1">
                        <p>They believed that to ensure a bright future, it was crucial to equip their peers and future generations with the skills to become strong leaders and citizens, empowering them to ignite change. </p>
                        <p>From that sunny Sunday in 2014, the vision of the SPARK Foundation materialized into reality. Over the years, the SPARK Foundation has implemented hundreds of educational programs, fostering growth both locally and internationally. Since that pivotal car ride, the founders and supporters have remained steadfast in their commitment to advocating for UN SDG #4 quality education and youth engagement. </p>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </section>

            {/* TEAM SECTION */}
            <section>
            <div className="bg-gray-100">

                <div className="mx-auto py-12 px-4 max-w-7xl sm:px-6 lg:px-8 lg:py-24">
                    <h2 className="text-4xl font-extrabold tracking-tight sm:text-4xl text-center mb-12">Meet The Team</h2>
                    <div className="space-y-12">
                    <h2 className="text-3xl font-medium tracking-wide text-spark-yellow text-center">Our Founders</h2>

                    <ul className="space-y-4 sm:grid sm:grid-cols-2 sm:gap-6 sm:space-y-0 lg:grid-cols-2 lg:gap-8">
                    {teamMembers.map((member, index) => {

                        if(member.node.teamMemberDetails.category === "Founders"){
                            return(
                                <li key={index} className="py-10 px-6 bg-white text-center rounded-lg xl:px-10 xl:text-left">

                                    <div className="space-y-6 xl:space-y-10">
                                        <img className="mx-auto h-40 w-40 rounded-full xl:w-56 xl:h-56" src={member.node.teamMemberDetails.picture.mediaItemUrl} alt=""/>
                                        <div className="space-y-2 xl:flex xl:items-center xl:justify-between">
                                            <div className="font-medium text-lg leading-6 space-y-1">
                                                <div className="leading-6 font-medium space-y-1">
                                                    <h3 className="text-xl">{member.node.title}</h3>
                                                    <p className="text-spark-yellow">{member.node.teamMemberDetails.position}</p>
                                                    <p className="text-gray-400">{member.node.teamMemberDetails.pronouns}</p>
                                                    <p className="text-md text-gray-400">{member.node.teamMemberDetails.email}</p>
                                                </div>
                                                
                                                <ul className="flex justify-center lg:justify-start space-x-3">
                                                    <li>
                                                    {member.node.teamMemberDetails.linkedin ? 
                                                        <a href={member.node.teamMemberDetails.linkedin} target="_blank" className="text-gray-400 hover:text-gray-500">
                                                            <span className="sr-only">LinkedIn</span>
                                                            <svg className="w-5 h-5" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
                                                                <path fillRule="evenodd" d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z" clipRule="evenodd" />
                                                            </svg>
                                                        </a>
                                                    : ""}
                                                    </li>
                                                </ul>
                                              
                                                <div className="pt-2">        
                                                 <p className="text-lg text-gray-500" dangerouslySetInnerHTML={{ __html: member.node.content }} />
                                                </div>
                                               
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            )
                        }
                    })}
                    </ul>

                    <h2 className="text-3xl font-medium tracking-wide text-spark-yellow text-center">SPARK Ambassadors</h2>
                    <ul className="space-y-4 sm:grid sm:grid-cols-2 sm:gap-6 sm:space-y-0 lg:grid-cols-3 lg:gap-8">
                    {teamMembers.map((member, index) => {

                        if(member.node.teamMemberDetails.category === "Empowerment Team"){
                            return(
                                <li key={index} className="py-10 px-6 bg-white text-center rounded-lg xl:px-10 xl:text-left">

                                <div className="space-y-6 xl:space-y-10">
                                    <img className="mx-auto h-40 w-40 rounded-full xl:w-56 xl:h-56" src={member.node.teamMemberDetails.picture.mediaItemUrl} alt=""/>
                                    <div className="space-y-2 xl:flex xl:items-center xl:justify-between">
                                        <div className="font-medium text-lg leading-6 space-y-1">
                                            <div className="leading-6 font-medium space-y-1">
                                                <h3 className="text-xl">{member.node.title}</h3>
                                                <p className="text-spark-yellow">{member.node.teamMemberDetails.position}</p>
                                                <p className="text-gray-400">{member.node.teamMemberDetails.pronouns}</p>
                                                <p className="text-md text-gray-400">{member.node.teamMemberDetails.email}</p>
                                            </div>
                                            
                                            <ul className="flex justify-center lg:justify-start space-x-3">
                                                <li>
                                                {member.node.teamMemberDetails.linkedin ? 
                                                    <a href={member.node.teamMemberDetails.linkedin} target="_blank" className="text-gray-400 hover:text-gray-500">
                                                        <span className="sr-only">LinkedIn</span>
                                                        <svg className="w-5 h-5" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
                                                            <path fillRule="evenodd" d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z" clipRule="evenodd" />
                                                        </svg>
                                                    </a>
                                                : ""}
                                                </li>
                                            </ul>
                                          
                                            <div className="pt-2">        
                                             <p className="text-lg text-gray-500" dangerouslySetInnerHTML={{ __html: member.node.content }} />
                                            </div>
                                           
                                        </div>
                                    </div>
                                </div>
                            </li>
                            )
                        }
                    })}
                    </ul>
                   

                    {/* <h2 className="text-3xl font-medium tracking-wide text-spark-yellow text-center">Our Inspiring Board Of Directions</h2>
                    <ul className="space-y-4 sm:grid sm:grid-cols-2 sm:gap-6 sm:space-y-0 lg:grid-cols-3 lg:gap-8">
                    {teamMembers.map((member, index) => {

                        if(member.node.teamMemberDetails.category === "Board Of Directors"){
                            return(
                                <li key={index} className="py-10 px-6 bg-white text-center rounded-lg xl:px-10 xl:text-left">

                                <div className="space-y-6 xl:space-y-10">
                                    <img className="mx-auto h-40 w-40 rounded-full xl:w-56 xl:h-56" src={member.node.teamMemberDetails.picture.mediaItemUrl} alt=""/>
                                    <div className="space-y-2 xl:flex xl:items-center xl:justify-between">
                                        <div className="font-medium text-lg leading-6 space-y-1">
                                            <div className="leading-6 font-medium space-y-1">
                                                <h3 className="text-xl">{member.node.title}</h3>
                                                <p className="text-spark-yellow">{member.node.teamMemberDetails.position}</p>
                                                <p className="text-gray-400">{member.node.teamMemberDetails.pronouns}</p>
                                                <p className="text-md text-gray-400">{member.node.teamMemberDetails.email}</p>
                                            </div>
                                            
                                            <ul className="flex justify-center lg:justify-start space-x-3">
                                                <li>
                                                {member.node.teamMemberDetails.linkedin ? 
                                                    <a href={member.node.teamMemberDetails.linkedin} target="_blank" className="text-gray-400 hover:text-gray-500">
                                                        <span className="sr-only">LinkedIn</span>
                                                        <svg className="w-5 h-5" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
                                                            <path fillRule="evenodd" d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z" clipRule="evenodd" />
                                                        </svg>
                                                    </a>
                                                : ""}
                                                </li>
                                            </ul>
                                          
                                            <div className="pt-2">        
                                             <p className="text-lg text-gray-500" dangerouslySetInnerHTML={{ __html: member.node.content }} />
                                            </div>
                                           
                                        </div>
                                    </div>
                                </div>
                            </li>
                            )
                        }
                    })}
                    </ul> */}
                    
                    </div>
                </div>
                </div>
            </section>

            {/* Team Image Grid*/}
            <section>
                <div className="relative">
                    <div className="grid grid-flow-col grid-cols-3 grid-rows-2">
                        <div><img className="object-cover h-full w-full shadow-md" src="images/about-us-collage1.jpg" alt=""/></div>
                        <div><img className="object-cover h-full w-full shadow-md" src="images/about-us-collage2.jpeg" alt=""/></div>
                        <div><img className="object-cover h-full w-full shadow-md" src="images/about-us-collage3.jpeg" alt=""/></div>
                        <div><img className="object-cover h-full w-full shadow-md" src="images/about-us-collage4.jpeg" alt=""/></div>
                        <div><img className="object-cover h-full w-full shadow-md" src="images/about-us-collage5.jpeg" alt=""/></div>
                        <div><img className="object-cover h-full w-full shadow-md" src="images/about-us-collage6.jpg" alt=""/></div>
                    </div>
                </div>
            </section>

        <Footer/>
        </div>
    )
}

export default AboutUs;